<template>
  <div class="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-1  tw-rounded-lg tw-bg-white tw-border tw-border-solid tw-border-[#DFE2E7]">
    <div class="tw-flex tw-items-center">
      <i class="fas fa-check tw-text-green-500 tw-mr-2" />
      {{ portfolio.name }}
    </div>
    <div>
      <StakeTooltip
        label="Please wait for analytics to finish loading before changing your portfolio selections"
        :active="checkupStore.isLoading"
      >
        <button
          :class="[
            'tw-rounded-lg tw-p-2 tw-border-none tw-bg-transparent tw-text-sm tw-font-medium',
            checkupStore.isLoading ? 'tw-text-gray-400' : 'tw-text-[#DE2131] tw-cursor-pointer',
          ]"
          @click="handleRemove"
        >
          Remove
        </button>
      </StakeTooltip>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import StakeTooltip from '@stakeui/StakeTooltip.vue';

import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'PortfolioButton',
  components: {
    StakeTooltip,
  },
  props: {
    portfolio: { type: Object, required: true },
  },
  data() {
    return { };
  },
  computed: { 
    ...mapStores(useCheckupStore),
  },
  methods: {
    handleRemove() {
      if (!this.checkupStore.isLoading) this.$emit('remove', this.portfolio);
    },
  },
};
</script>